export const DETAILCONFIG: any = {
    like: {
        header: 'like details',
        table_header: [
            {
                th_name: "Planet",
                th_classname: "col-3 ",
            },
            {
                th_name: "Name",
                th_classname: "col-3",
            },
            {
                th_name: "date",
                th_classname: "col-3",
            },
            {
                th_name: "time",
                th_classname: "col-3",
            },
        ],
        table_content: [
            {
                td_name: "category_image_url",
            },
            {
                td_name: "pro_name",
            },
            {
                td_name: "created",
            },
        ]
    },
    engage: {
        header: 'engage details',
        table_header: [
            {
                th_name: "Planet",
                th_classname: "col-3 ",
            },
            {
                th_name: "Name",
                th_classname: "col-3",
            },
            {
                th_name: "date",
                th_classname: "col-3",

            },
            {
                th_name: "time",
                th_classname: "col-3",

            }
        ],
        table_content: [
            {
                td_name: "category_image_url",
            },
            {
                td_name: "pro_name",
            },
            {
                td_name: "created",
            },


        ]
    }
}